export default {
  status: {
    success: 'There is no data to display.',
    error: 'Error loading data.',
  },
};
